export default "__VITE_ASSET__CTu6XstM__"